import React from 'react'

const EventDrawerTabs = ({
  toggle,
  setToggle
}) => {
  const tabs = [
    {
      id: "1",
      name: "Today"
    },
    {
      id: "2",
      name: "Past"
    },
    {
      id: "3",
      name: "Upcoming"
    },
    {
      id: "4",
      name: "Archived"
    }
  ]


  return (
    <div className="toggle-bar mt-10 justify-content-between">
      {tabs.map((tab, index) => (
        <p
          id={tab.id}
          key={tab.id}
          className={
            toggle == tab.id ? "selected tab-title" : "unselected tab-title"
          }
          style={{
            clear: "both",
            display: "inline-block",
            overflow: 'hidden',
            whiteSpace: "nowrap",
            maxWidth: "180px",
          }}
          title={tab.name}
          onClick={(e) => setToggle(e.target.id)}
        >
          {tab.name}
        </p>
      ))}
    </div>
  )
}

export default EventDrawerTabs